/**
 * The browser tab title: the page's own title with the brand once at the end, in the page's language
 * ("| Saleem", or "| سليم" on Arabic pages, as the server's titles already end). A title that already
 * ends with either is left as it is; an empty one, or one that is only the brand, is just the brand.
 */
export function pageTitle(title, lang) {
  const brand = lang === 'ar' ? 'سليم' : 'Saleem'
  if (!title || /^\s*(Saleem|سليم)\s*$/.test(title)) return brand
  return /\|\s*(Saleem|سليم)\s*$/.test(title) ? title : `${title} | ${brand}`
}
